export default __webpack_public_path__ + "static/media/gl-6.4407ac9e.png";